export default __webpack_public_path__ + "static/media/zoom.65d93efb.png";